export const BLOG_ITEMS_RECEIVED = 'BLOG_ITEMS_RECEIVED';
